"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _socialLink = _interopRequireDefault(require("../styles/social-link.css"));
var _footer = require("./footer.propTypes");
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;
var SocialLink = function SocialLink(_ref) {
  var oneSocialLink = _ref.oneSocialLink;
  return oneSocialLink.openNewTab === true ? /*#__PURE__*/_react["default"].createElement("a", {
    target: "_blank",
    className: _socialLink["default"].link,
    rel: "noopener noreferrer",
    href: handleNestedProp(oneSocialLink, 'oneSocialLink.url'),
    "aria-label": handleNestedProp(oneSocialLink, 'oneSocialLink.url')
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _socialLink["default"].imageSocialLink,
    src: handleNestedProp(oneSocialLink, 'oneSocialLink.image.image'),
    alt: handleNestedProp(oneSocialLink, 'oneSocialLink.image.altText')
  })) : /*#__PURE__*/_react["default"].createElement("a", {
    className: _socialLink["default"].link,
    href: handleNestedProp(oneSocialLink, 'oneSocialLink.url'),
    "aria-label": handleNestedProp(oneSocialLink, 'oneSocialLink.url')
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _socialLink["default"].imageSocialLink,
    src: handleNestedProp(oneSocialLink, 'oneSocialLink.image.image'),
    alt: handleNestedProp(oneSocialLink, 'oneSocialLink.image.altText')
  }));
};
SocialLink.displayName = 'SocialLink';
var _default = SocialLink;
exports["default"] = _default;